import { SiteControlLayout, SiteControlWidget } from '@scaleaq/sitecontrol-lib';
import { deepEqual } from 'fast-equals';

type WidgetWithMaxConstraints = SiteControlWidget & {
  maxW?: number;
  maxH?: number;
  minW?: number;
  minH?: number;
  isChanged?: boolean;
};

const normalizeLayoutExcludeSome = (layout: SiteControlLayout) => {
  return {
    ...layout,
    widgets: layout.widgets
      .map(w => {
        // oxlint-disable-next-line typescript/no-unused-vars
        const { maxH, maxW, minW, minH, isChanged, ...rest } = w as WidgetWithMaxConstraints;
        return rest;
      })
      .sort((a, b) => a.id.localeCompare(b.id)),
  };
};

export const areLayoutsEqual = ({
  currentLayout,
  currentDbLayout,
}: {
  currentLayout: SiteControlLayout;
  currentDbLayout: SiteControlLayout;
}): boolean => {
  return deepEqual(
    normalizeLayoutExcludeSome({ ...currentLayout, version: currentDbLayout.version }),
    normalizeLayoutExcludeSome(currentDbLayout)
  );
};
